import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Imagen de fondo */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/220e8a017f55ffc9ba1f57e20a368416.jpg"
          alt="Servicio profesional de vaciado de pisos en Vic"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Contenido */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight px-2">
          Vaciado de pisos y locales en Vic
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-white/95 mb-4 max-w-3xl mx-auto font-medium px-4">
          Especialistas en limpieza por síndrome de Diógenes y suciedad extrema
        </p>
        <p className="text-sm sm:text-base md:text-lg text-white/90 mb-10 max-w-2xl mx-auto px-4">
          Servicio profesional, discreto y urgente en Vic, Osona y comarca. Más de 10 años de experiencia y +500 pisos vaciados con total garantía.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center px-4">
          <a
            href="tel:+34602365996"
            className="w-full sm:w-auto bg-primary text-white px-6 sm:px-8 py-4 rounded-lg font-bold text-sm sm:text-base hover:bg-red-700 transition-all duration-300 shadow-2xl hover:shadow-primary/50 hover:scale-105 whitespace-nowrap inline-flex items-center justify-center cursor-pointer"
            aria-label="Llamar al 602 36 59 96"
          >
            <i className="ri-phone-line mr-2 text-xl"></i>
            <span className="truncate">Llamar Ahora: 602 36 59 96</span>
          </a>
          <a
            href="https://wa.me/34602365996"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto bg-green-500 text-white px-6 sm:px-8 py-4 rounded-lg font-bold text-sm sm:text-base hover:bg-green-600 transition-all duration-300 shadow-2xl hover:shadow-green-500/50 hover:scale-105 whitespace-nowrap inline-flex items-center justify-center cursor-pointer"
            aria-label="Contactar por WhatsApp"
          >
            <i className="ri-whatsapp-line mr-2 text-xl"></i>
            WhatsApp
          </a>
        </div>

        {/* Badges */}
        <div className="mt-12 flex flex-wrap justify-center gap-4 sm:gap-6 text-white px-4">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
              <i className="ri-time-line text-2xl text-secondary"></i>
            </div>
            <span className="text-xs sm:text-sm font-medium">Servicio 24h</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-2xl text-secondary"></i>
            </div>
            <span className="text-xs sm:text-sm font-medium">100% Discreto</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
              <i className="ri-file-list-3-line text-2xl text-secondary"></i>
            </div>
            <span className="text-xs sm:text-sm font-medium">Presupuesto Sin Compromiso</span>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-3xl text-white"></i>
        </div>
      </div>
    </section>
  );
}
